const QUERY_TRANSACTION_GIFT = 'transaction_gift';

export default defineNuxtRouteMiddleware(async(to) => {
    if (QUERY_TRANSACTION_GIFT in to.query) {
        const transaction = to.query.id;

        const { error, status } = await useAsyncFetchLaravel(`/v2.0/gift/${transaction}`, {
            method: 'GET'
        });

        if (status.value === 'error') {
            if (error) {
                let redirectUrl = '/';

                if ('failed' in to.query) {
                    redirectUrl += to.query.failed;
                }

                return navigateTo(redirectUrl);
            }
        }
    }
});
